// extracted by mini-css-extract-plugin
export default {"button":"DiceContainer_button__Q0TND","customDiceRollOpen":"DiceContainer_customDiceRollOpen__vNFet","floatingArrow":"DiceContainer_floatingArrow__02TqU"};